<template>
  <div id="BillPaymentBarcode_PrintTemplate">
    <!-- 標題區 -->
    <section class="header">
      <div class="header-content">
        <img src="@/assets/img/print/LOGONAME.png" class="logo"/>

        <div class="title">綜合帳單繳費條碼</div>
      </div>
    </section>

    <!-- 金額與期限 -->
    <section class="amount-date">
      <div class="amount">
        <span class="title">應繳金額</span>
        <span class="text-red">{{ data.total }}</span>
      </div>

      <div class="due-date">
        <span class="title">繳費期限</span>
        <span>{{ convertRocDate(getFirstAndLastDayOfMonth(data.created_at).last_day) }}</span>
      </div>
    </section>

    <!-- 郵政劃撥 條碼區 -->
    <section class="barCode">
      <div class="post">
        <div class="title">郵政劃撥 專用條碼</div>

        <div class="content">
          <div class="barCode-info">
            <img :id="`barCode2_${data.id}`" />

            <span class="text">劃撥帳號:{{ data.barCode2 }}</span>
          </div>

          <div class="barCode-info">
            <img :id="`barCode3_${data.id}`" />

            <span class="text">寄款人代號:{{ data.barCode3 }}</span>
          </div>

          <div class="barCode-info">
            <img :id="`barCode4_${data.id}`" />

            <span class="text">金額:{{ data.barCode4 }}</span>
          </div>
        </div>
      </div>

      <div class="bank">
        <div class="title">台中銀行 專用條碼</div>

        <div class="content">
          <div class="barCode-info">
            <img :id="`barCode8_${data.id}`" />

            <span class="text">虛擬帳號:{{ data.virtual_account }}</span>
          </div>

          <div class="barCode-info">
            <img :id="`barCode9_${data.id}`" />

            <span class="text">金額:{{ data.barCode4 }}</span>
          </div>
        </div>
      </div>

      <div class="store">
        <div class="title">7-11、全家、萊爾富 專用條碼</div>

        <div class="content">
          <div class="barCode-info">
            <img :id="`barCode5_${data.id}`" />

            <span class="text">條碼一:{{ data.barCode5 }}</span>
          </div>

          <div class="barCode-info">
            <img :id="`barCode6_${data.id}`" />

            <span class="text">條碼二:{{ data.barCode6 }}</span>
          </div>

          <div class="barCode-info">
            <img :id="`barCode7_${data.id}`" />

            <span class="text">條碼三:{{ data.barCode7 }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import jsbarcode from 'jsbarcode';
import { convertRocDate, getFirstAndLastDayOfMonth } from "@/models/HELPERS/common.js";

export default {
  name: 'BillPaymentBarcode',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.generateBarcode();
        });
      },
      immediate: false
    }
  },
  data () {
    return {

    }
  },

  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.$nextTick(() => {
        this.generateBarcode();
      });
    },
    convertRocDate,
    getFirstAndLastDayOfMonth,
    generateBarcode() {
      jsbarcode(`#barCode2_${this.data.id}`, this.data.barCode2, {
        format: "CODE39",
        // width: 1.5,
        // height: 25,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode3_${this.data.id}`, this.data.barCode3, {
        format: "CODE39",
        // width: 1,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode4_${this.data.id}`, this.data.barCode4, {
        format: "CODE39",
        // width: 2,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        // font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode5_${this.data.id}`, this.data.barCode5, {
        format: "CODE39",
        // width: 1,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode6_${this.data.id}`, this.data.barCode6, {
        format: "CODE39",
        // width: 1,
        // height: 25,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode7_${this.data.id}`, this.data.barCode7, {
        format: "CODE39",
        // width: 1,
        // height: 15,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode8_${this.data.id}`, this.data.virtual_account, {
        format: "CODE39",
        // width: 1,
        // height: 15,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        font: "DFKai-sb",
        displayValue: false
      });
      jsbarcode(`#barCode9_${this.data.id}`, this.data.barCode4, {
        format: "CODE39",
        // width: 2,
        // height: 20,
        // fontSize: 14,
        // margin: 0,
        marginBottom: 5,
        // textMargin: 0,
        // font: "DFKai-sb",
        displayValue: false
      });
    },
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#BillPaymentBarcode_PrintTemplate {
  width: 560px;
  height: 794px;
  background: #f5f5f5;
  line-height: 1.2;
  .text-red {
    color: #fa1d1d;
  }
  .header {
    .header-content {
      display: flex;
      align-items: center;
      column-gap: 20px;
      height: 45px;
      background: white;
      .logo {
        height: 100%;
        width: 190px;
      }
      .title {
        flex: 1;
        height: 100%;
        font-size: 26px;
        font-weight: bold;
        color: white;
        position: relative; /* 為了讓 ::before 定位基於 .title */
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 50px;
        z-index: 1; /* 確保內容在偽元素之上 */
        background: none; /* 將背景移到偽元素 */
        &::before {
          content: '';
          position: absolute;
          top: 0;
          right: -16px;
          width: 100%;
          height: 100%;
          background: #fa1d1d;
          z-index: -1; /* 確保背景在內容下方 */
          transform: skewX(-35deg); /* 模擬斜角 */
          transform-origin: left; /* 設置斜角基準點 */
        }
      }
    }
  }
  .amount-date {
    background: white;
    margin: 10px 20px;
    padding: 5px 20px;
    .amount,
    .due-date {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      font-weight: bold;
      .title {
        color: #827878;
      }
    }
  }
  .barCode {
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    .post,
    .bank,
    .store {
      .title {
        text-align: center;
        font-size: 22px;
        font-weight: bold;
      }
      .content {
        background: white;
        padding: 10px;
        .barCode-info {
          display: flex;
          align-items: center;
          flex-direction: column;
          img {
            width: 400px;
            height: 40px;
          }
          .text {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
          }
        }
      }
    }
    // .bottom {
    //   display: grid;
    //   grid-template-columns: 1fr 1fr;
    //   column-gap: 20px;
    //   margin-top: 20px;
    //   .bank {
    //     .title {
    //       text-align: center;
    //       font-size: 22px;
    //       font-weight: bold;
    //     }
    //     .content {
    //       background: white;
    //       padding: 5px;
    //       .barCode-info {
    //         display: flex;
    //         align-items: center;
    //         flex-direction: column;
    //         img {
    //           width: 100%;
    //           height: 45px;
    //         }
    //         .content {
    //           font-size: 16px;
    //           font-weight: bold;
    //           text-align: center;
    //         }
    //       }
    //     }
    //   }
    //   .store {
    //     .title {
    //       text-align: center;
    //       font-size: 22px;
    //       font-weight: bold;
    //     }
    //     .content {
    //       background: white;
    //       padding: 5px;
    //       .barCode-info {
    //         display: flex;
    //         align-items: center;
    //         flex-direction: column;
    //         img {
    //           width: 100%;
    //           height: 45px;
    //         }
    //         .content {
    //           font-size: 16px;
    //           font-weight: bold;
    //           text-align: center;
    //         }
    //       }
    //     }
    //   }
    // }
  }

  .barcode-section {
    margin-top: 20px;

    .barcode-block {
      margin-bottom: 20px;

      p {
        font-size: 14px;
        margin-bottom: 5px;
      }

      .barcode {
        width: 100%;
        max-width: 400px;
        height: auto;
      }
    }
  }

  .footer-barcode {
    text-align: center;
    margin-top: 20px;

    p {
      font-size: 12px;
      color: #555;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/BillPaymentBarcode.vue